import React, { useEffect, useState, useCallback } from "react";
import { Container, Form } from "react-bootstrap";
import { MdOutlineFileUpload } from "react-icons/md";
import axios from "axios";
import apiUrls from "../../../Api/MainApi";
import { MDBInput } from "mdb-react-ui-kit";
import { Select } from "antd";

const CourseForm = ({ formData, setFormData, setIsFormValid }) => {
  const [errors, setErrors] = useState({});
  const [CourseValue, setCourseValue] = useState([]);
  const [fileNames, setFileNames] = useState({}); // State to hold file names

  useEffect(() => {
    const fetchData = async () => {
      const getCourse = await axios.get(apiUrls.GetCourseDropDown);
      setCourseValue(getCourse.data.data);
    };
    // Pre-fill the FYYear with the current year and next year
   


    fetchData();
  }, []);
  useEffect(() => {
    const currentYear = new Date().getFullYear();
    const nextYear = currentYear + 1;
    
    // Only update FYYear if necessary
    const newFYYear = formData.isTaxPayer ? `${currentYear}-${nextYear}` : "";
    if (formData.FYYear !== newFYYear) {
      setFormData(prevData => ({
        ...prevData,
        FYYear: newFYYear,
      }));
    }
  }, [formData.isTaxPayer]);
  

  const regexPatterns = {
    PassingYear: /^\d{4}$/, // 4-digit year format
    AddharNo: /^\d{12}$/, // 12-digit Aadhar number
    PANNO: /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/, // PAN card format
    TaxCode: /^[A-Z]{3}\d{6}$/, // Tax code format
    FYYear: /^\d{4}-\d{4}$/, // Financial year format
  };

  const allowedFileTypes = ['image/jpeg', 'image/png', 'application/pdf'];

  const handleChange = (e) => {
    const { name, value, type, files, checked } = e.target;
    let fieldValue = value;

    if (name === "PANNO") {
      fieldValue = value.toUpperCase();
    }
    if (name === "AddharNo") {
      fieldValue = value.replace(/\D/g, ''); // Remove non-numeric characters
      if (fieldValue.length > 12) {
        fieldValue = fieldValue.slice(0, 12); // Limit to 12 digits
      }
    }
    if (name === "TaxCode") {
      fieldValue = value.toUpperCase();
    }

    // Allow typing for financial year and validate
    if (name === "FYYear") {
      const currentYear = new Date().getFullYear();
      const currentFinancialYear = `${currentYear}-${currentYear + 1}`;

      // Set error if value is not the current financial year
      if (value && value !== currentFinancialYear) {
        setErrors(prevErrors => ({ ...prevErrors, [name]: "Invalid Financial Year. Only current FY allowed." }));
        setIsFormValid(false);
      } else {
        setErrors(prevErrors => ({ ...prevErrors, [name]: "" }));
        setIsFormValid(true);
      }
    }



    if (regexPatterns[name] && !regexPatterns[name].test(fieldValue)) {
      setErrors(prevErrors => ({ ...prevErrors, [name]: `Invalid ${name}` }));
      setIsFormValid(false)
    } else {

      setErrors(prevErrors => ({ ...prevErrors, [name]: "" }));
      setIsFormValid(true)
    }
    if (type === "file") {
      if (files[0]) {
        if (!allowedFileTypes.includes(files[0].type)) {
          setErrors(prevErrors => ({ ...prevErrors, [name]: "File type not allowed" }));
          return;
        }
        handleFileUpload(files[0], name);
        setFileNames(prevFileNames => ({ ...prevFileNames, [name]: files[0].name })); // Set file name
        // Update the file name in formData separately
        // setFormData(prevFormData => ({
        //   ...prevFormData,
        //   [`${name}Name`]: files[0].name, // Store the file name separately
        // }));
      }
      return;
    }
    else if (type === "radio") {
      fieldValue = checked ? true : false;
    }



    if (name === "PassingYear") {
      // Update the form data first
      setFormData(prevFormData => ({
        ...prevFormData,
        [name]: fieldValue,
      }));
  
      // Only validate when the input is 4 digits long
      if (fieldValue.length === 4) {
        const currentYear = new Date().getFullYear();
        const minYear = currentYear - 80; // 80 years ago
  
        if (fieldValue > currentYear || fieldValue < minYear) {
          setErrors(prevErrors => ({
            ...prevErrors,
            [name]: `Passing year must be between ${minYear} and ${currentYear}.`
          }));
          setIsFormValid(false);
        } else {
          setErrors(prevErrors => ({
            ...prevErrors,
            [name]: ""
          }));
          setIsFormValid(true);
        }
      } 
  
    }


    setFormData(prevFormData => ({
      ...prevFormData,
      [name]: fieldValue,
    }));
  };


  const handleFileUpload = useCallback((file, fieldName) => {
    const reader = new FileReader();

    reader.onloadend = () => {
      const fileData = {
        name: file.name,
        data: reader.result,
      };

      const fileDataString = JSON.stringify(fileData);

      setFormData(prevFormData => ({
        ...prevFormData,
        [fieldName]: fileDataString,
      }));
    };

    reader.readAsDataURL(file); // Convert file to base64
  }, [setFormData]);


  const handleRadioChange = (value) => {
    setFormData(prevFormData => ({
      ...prevFormData,
      isTaxPayer: value,
    }));
  };
  // Handler for bank name selection
  const handlCourseNameChange = (selectedOption) => {

    setFormData(prevFormData => ({
      ...prevFormData,
      Course: selectedOption, // Set the selected bank object
    }));
  };
  const filterOption = (input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase());
  return (
    <div className="FormCss">
      <Container className="form-container">
        <Form className="form-md" autoComplete="off">

          {/* Course Section */}
          <div className="form-section">
            <h3>Course</h3>
            <div className="d-flex gap-3 flex-wrap">
              <div className="form-group">

                <Select
                  name="Course"
                  value={formData.Course}
                  onChange={handlCourseNameChange}
                  options={(CourseValue || []).map((course) => ({ value: course.id, label: course.name }))}
                  placeholder="Select Course"
                  required
                  id="Course"
                  style={{ width: '100%', height: "42px" }}
                  filterOption={filterOption}
                />
                {errors.Course && (
                  <p style={{ color: 'red' }}>{errors.Course}</p>
                )}
              </div>
              <div className="form-group">
                <MDBInput
                  type="text"
                  name="InstituteName"
                  value={formData.InstituteName}
                  onChange={handleChange}
                  required
                  id="InstituteName"
                  label="Board Name"
                  placeholder="Example: Mumbai University"
                />
                {errors.InstituteName && (
                  <p style={{ color: 'red' }}>{errors.InstituteName}</p>
                )}
              </div>
            </div>
            <div className="d-flex gap-3 flex-wrap">
              <div className="form-group">
                <MDBInput
                  type="text"
                  name="PassingYear"
                  value={formData.PassingYear}
                  onChange={handleChange}
                  required
                  id="PassingYear"
                  minLength="4"
                  maxLength="4"
                  label="Passing Year"
                  placeholder="Example: 2024"
                />
                {errors.PassingYear && (
                  <p style={{ color: "red" }}>{errors.PassingYear}</p>
                )}
              </div>
              <div className="form-group">
                <div className="input-group" style={{ position: "relative" }}>
                  <MdOutlineFileUpload className="upload-icon-for-inputs" />
                  <Form.Control
                    style={{ cursor: "pointer", borderRadius: "5px", paddingLeft: "40px" }}
                    type="text"
                    value={fileNames.Document || ""}
                    placeholder="Upload Certificate Copy"
                    readOnly
                    onClick={() => document.getElementsByName("Document")[0].click()}
                    accept='image/*,.pdf'
                  />

                  <Form.Control
                    type="file"
                    name="Document"
                    onChange={handleChange}
                    style={{ display: "none" }}
                    accept='image/*,.pdf'

                  />
                  {errors.Document && (
                    <p style={{ color: "red" }}>{errors.Document}</p>
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* Identity Proof Section */}
          <div className="form-section">
            <h3>Identity Proof</h3>
            <div className="d-flex gap-3 flex-wrap">
              <div className="form-group">
                <MDBInput
                  type="text"
                  name="AddharNo"
                  value={formData.AddharNo}
                  onChange={handleChange}
                  required
                  id="AddharNo"
                  minLength="12"
                  maxLength="12"
                  label="Aadhaar No"
                  placeholder="Example: 123456789012"
                />
                {errors.AddharNo && (
                  <p style={{ color: "red" }}>{errors.AddharNo}</p>
                )}
              </div>
              <div className="form-group">
                <div className="input-group" style={{ position: "relative" }}>
                  <MdOutlineFileUpload className="upload-icon-for-inputs" />
                  <Form.Control
                    style={{ cursor: "pointer", borderRadius: "5px", paddingLeft: "40px" }}
                    type="text"
                    value={fileNames.AddharFile || ""}
                    placeholder="Upload Aadhaar Card Copy"
                    readOnly
                    onClick={() => document.getElementsByName("AddharFile")[0].click()}
                    accept='image/*,.pdf'
                  />
                  <Form.Control
                    type="file"
                    name="AddharFile"
                    onChange={handleChange}
                    style={{ display: "none" }}
                    accept='image/*,.pdf'

                  />
                  {errors.AddharFile && (
                    <p style={{ color: "red" }}>{errors.AddharFile}</p>
                  )}
                </div>
              </div>
            </div>
            <div className="d-flex gap-3 flex-wrap">
              <div className="form-group">
                <MDBInput
                  type="text"
                  name="PANNO"
                  value={formData.PANNO}
                  onChange={handleChange}
                  required
                  id="PANNO"
                  minLength="10"
                  maxLength="10"
                  label="PAN No"
                  placeholder="Example: ABCDE1234F"
                />
                {errors.PANNO && (
                  <p style={{ color: "red" }}>{errors.PANNO}</p>
                )}
              </div>
              <div className="form-group">
                <div className="input-group" style={{ position: "relative" }}>
                  <MdOutlineFileUpload className="upload-icon-for-inputs" />
                  <Form.Control
                    style={{ cursor: "pointer", borderRadius: "5px", paddingLeft: "40px" }}
                    type="text"
                    value={fileNames.PANFILE || ""}
                    placeholder="Upload PAN Card Copy"
                    readOnly
                    onClick={() => document.getElementsByName("PANFILE")[0].click()}
                  />
                  <Form.Control
                    type="file"
                    name="PANFILE"
                    onChange={handleChange}
                    style={{ display: "none" }}
                    accept='image/*,.pdf'

                  />
                  {errors.PANFILE && (
                    <p style={{ color: "red" }}>{errors.PANFILE}</p>
                  )}
                </div>
              </div>
            </div>
            <div className="form-group">
              <div className="input-group" style={{ position: "relative" }}>
                <MdOutlineFileUpload className="upload-icon-for-inputs" />
                <Form.Control
                  style={{ cursor: "pointer", borderRadius: "5px", paddingLeft: "40px" }}
                  type="text"
                  value={fileNames.ProfilePic || ""}
                  placeholder="Upload Profile Photo"
                  readOnly
                  onClick={() => document.getElementsByName("ProfilePic")[0].click()}
                />
                <Form.Control
                  type="file"
                  name="ProfilePic"
                  onChange={handleChange}
                  style={{ display: "none" }}
                  accept='image/*,.pdf'

                />
                {errors.ProfilePic && (
                  <p style={{ color: "red" }}>{errors.ProfilePic}</p>
                )}
              </div>
            </div>
          </div>

          {/* Tax Section */}
          <div className="form-section">
            <h3>Tax Details</h3>
            <div className="d-flex gap-3 flex-wrap">
              <div className="form-group d-flex ">
                <Form.Check
                  type="radio"
                  name="isTaxPayer"
                  value={true}
                  label="Yes"
                  checked={formData.isTaxPayer === true}
                  onChange={() => handleRadioChange(true)}
                  style={{ width: "20%" }}
                />
                <Form.Check
                  type="radio"
                  name="isTaxPayer"
                  value={false}
                  label="No"
                  checked={formData.isTaxPayer === false}
                  onChange={() => handleRadioChange(false)}
                  style={{ width: "20%" }}
                />
              </div>
            </div>
            {formData.isTaxPayer === true && (
              <>
                <div className="d-flex gap-3 flex-wrap">
                  <div className="form-group">
                    <MDBInput
                      type="text"
                      name="TaxCode"
                      value={formData.TaxCode}
                      onChange={handleChange}
                      required
                      id="TaxCode"
                      label="Tax Code"
                      placeholder="Example: ABC123456"
                    />
                    {errors.TaxCode && (
                      <p style={{ color: "red" }}>{errors.TaxCode}</p>
                    )}
                  </div>
                  <div className="form-group">
                    <MDBInput
                      type="text"
                      name="FYYear"
                      value={formData.FYYear}
                      onChange={handleChange}
                      required
                      id="FYYear"
                      minLength="9"
                      maxLength="9"
                      disabled
                      label="Financial Year"
                      placeholder={`Example: ${new Date().getFullYear()}-${new Date().getFullYear() + 1}`}
                    />

                    {errors.FYYear && (
                      <p style={{ color: "red" }}>{errors.FYYear}</p>
                    )}
                  </div>
                </div>
                <div className="form-group">
                  <div className="input-group" style={{ position: "relative" }}>
                    <MdOutlineFileUpload className="upload-icon-for-inputs" />
                    <Form.Control
                      style={{ cursor: "pointer", borderRadius: "5px", paddingLeft: "40px" }}
                      type="text"
                      value={formData.TaxDoc ? formData.TaxDoc.name : ""}
                      placeholder="Upload Tax Filing Document"
                      readOnly
                      onClick={() => document.getElementsByName("TaxDoc")[0].click()}
                    />
                    <Form.Control
                      type="file"
                      name="TaxDoc"
                      onChange={handleChange}
                      style={{ display: "none" }}
                      accept='image/*,.pdf'

                    />
                    {errors.TaxDoc && (
                      <p style={{ color: "red" }}>{errors.TaxDoc}</p>
                    )}
                  </div>
                </div>
              </>
            )}
          </div>
        </Form>
      </Container>
    </div>
  );
};

export default CourseForm;
